export const getClientListFromResponse = (clientListResponse) => {
  const clientList = Array.isArray(clientListResponse)
    ? clientListResponse
    : [];

  const allClient = clientList.find(
    (clientOption) => clientOption?.name === "ALL"
  );
  const otherClients = clientList.filter(
    (clientOption) => clientOption?.name !== "ALL"
  );

  otherClients.sort((clientA, clientB) =>
    String(clientA?.name || "").localeCompare(String(clientB?.name || ""))
  );

  return allClient ? [allClient, ...otherClients] : otherClients;
};

export const mapClientOptionToDropdownValue = (clientOption) => {
  if (!clientOption?._id || !clientOption?.name) {
    return null;
  }

  return {
    id: clientOption._id,
    label: clientOption.name,
    value: clientOption._id,
  };
};

export const getClientDropdownValues = (clientListResponse) => {
  return getClientListFromResponse(clientListResponse)
    .map((clientOption) => {
      return mapClientOptionToDropdownValue(clientOption);
    })
    .filter(Boolean);
};

export const mapClientOptionToNameDropdownValue = (clientOption) => {
  if (!clientOption?._id || !clientOption?.name) {
    return null;
  }

  return {
    id: clientOption._id,
    label: clientOption.name,
    value: clientOption.name,
  };
};

export const getClientNameDropdownValues = (clientListResponse) => {
  return getClientListFromResponse(clientListResponse)
    .map((clientOption) => {
      return mapClientOptionToNameDropdownValue(clientOption);
    })
    .filter(Boolean);
};

export const getClientIdByName = (clientListResponse, clientName) => {
  const selectedClientName = String(clientName || "").trim();

  if (!selectedClientName) {
    return null;
  }

  const matchingClient = getClientListFromResponse(clientListResponse).find(
    (clientOption) => {
      const optionName = clientOption?.name;
      return String(optionName || "").trim() === selectedClientName;
    }
  );

  return matchingClient?._id ?? null;
};
